import { makeEditable, createEditableElement } from '@bikemap/js/integrations/editable'
import { defaultPost } from '@bikemap/js/utility'
import { gettext, notifications } from '@bikemap/js/services'

let addTag
let tagsContainer

function handleTitleSubmit(value, element) {
    if (!value) {
        notifications.show({
            message: gettext('Please provide a title for your route collection!'),
            icon: 'i-warning-sign',
            type: 'danger',
        })
        return false
    }
    const body = new FormData
    body.append('value', value)
    body.append('pk', element.node.dataset.pk)
    return defaultPost(element.node.dataset.url, body)
        .then(res => {
            if (!res.success) {
                notifications.show({
                    message: res.error,
                    icon: 'i-warning-sign',
                    type: 'danger',
                })
            } else {
                document.querySelector('#breadcrumb-list .active').textContent = value
                document.title = document.title.replace(element.originalValue, value)
                return value
            }
        })
        .catch(res => notifications.error(res.statusText))
}

function handleDescriptionSubmit(value, element) {
    const body = new FormData
    body.append('value', value)
    body.append('pk', element.node.dataset.pk)
    return defaultPost(element.node.dataset.url, body)
        .then(res => {
            if (!res.success) {
                notifications.show({
                    message: res.error,
                    icon: 'i-warning-sign',
                    type: 'danger',
                })
            } else {
                return value
            }
        })
        .catch(res => notifications.error(res.statusText))
}

function handleTagsSubmit(value) {
    const body = new FormData
    body.append('name', 'tags')
    body.append('pk', tagsContainer.dataset.pk)
    const tags = tagsContainer.querySelectorAll('.tag')
    for (let i = 0; i < tags.length; i++) {
        const content = tags[i].textContent.trim()
        body.append('value[]', content)
    }
    let newTags = []
    if (value) {
        newTags = value.split(' ')
        newTags.forEach(v => body.append('value[]', v))
    }
    return defaultPost(tagsContainer.dataset.url, body)
        .then(res => {
            if (res.success) {
                newTags.forEach(value => {
                    const newTag = document.createElement('span')
                    newTag.setAttribute('class', 'tag')
                    newTag.innerHTML = '<button class="remove-btn"><i class="i-close i-sm text-white"></i></button>'
                    newTag.prepend(document.createTextNode(value))
                    setTagRemoveHandler(newTag)
                    tagsContainer.insertBefore(newTag, addTag)
                })
                return ''
            }
            notifications.show({
                message: res.error,
                icon: 'i-warning-sign',
                type: 'danger',
            })
        })
        .catch(res => notifications.error(res.statusText))
}

function setTagRemoveHandler(tag) {
    tag.querySelector('.remove-btn').addEventListener('click', e => {
        tagsContainer.removeChild(tag)
        handleTagsSubmit()
    })
}

function initTags() {
    addTag = document.getElementById('add-tag')
    tagsContainer = document.getElementById('tags')
    createEditableElement(addTag, handleTagsSubmit)

    const tags = tagsContainer.querySelectorAll('.tag')
    for (const tag of tags) {
        setTagRemoveHandler(tag)
    }
}

function initVisibility() {
    const container = document.getElementById('visibility')
    const choices = document.querySelectorAll('#visibility-list a')
    const buttonContent = document.querySelector('#visibility-btn .content')
    for (let i = 0; i < choices.length; i++) {
        const choice = /** @type {HTMLElement} */ (choices[i])
        choice.addEventListener('click', e => {
            e.preventDefault()
            const body = new FormData
            body.append('pk', container.dataset.pk)
            const value = choice.dataset.value
            body.append('value', value)
            defaultPost(container.dataset.url, body)
                .then(res => {
                    if (res.success) {
                        buttonContent.textContent = choices[i].textContent
                        document.querySelector('.title .private-indicator').classList.toggle('hidden', value !== '0')
                        document.querySelector('.title .hidden-indicator').classList.toggle('hidden', value !== '1')
                    }
                })
                .catch(res => notifications.error(res.statusText))
        })
    }
}

export function makeRouteCollectionEditable() {
    makeEditable(document.getElementById('collection-title'), handleTitleSubmit)
    makeEditable(document.getElementById('description'), handleDescriptionSubmit)
    initTags()
    initVisibility()
}
